<template>
  <div class="post-preview-section-skeleton">
    <div class="post-preview-section">
      <div class="post-preview-section__post-snippet-wrap">
        <div class="post-preview-section__slot-wrap">
          <slot />
        </div>

        <div class="post-preview-section__snippet">
          <span class="post-preview-section__snippet-text">
            Escape to adventure in Visit Funtown, where every sunset paints the sky and the water awaits your paddle. Discover tranquility, capture the moment, and feel the thrill of nature's beauty.
          </span>

          <div class="photos-section">
            <div class="photos-section__photo photos-section__photo--big"></div>
            <div class="photos-section__photo photos-section__photo--big"></div>
            <div class="photos-section__photo photos-section__photo--small"></div>
            <div class="photos-section__photo photos-section__photo--small"></div>
            <div class="photos-section__photo photos-section__photo--small"></div>
          </div>

          <div class="buttons-panel">
            <div class="buttons-panel__button buttons-panel__button--big"></div>
            <div class="buttons-panel__button buttons-panel__button--small"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
@import "@/scss/mixins/animations/skeleton-loading.scss";
@import "@/scss/mixins/animations/loading-bg.scss";

// Post preview section =======================================================
.post-preview-section {
  display: flex;
  flex-direction: column;

  &__post-snippet-wrap {
    flex-grow: 1;
    padding: 12px 3px 13px;
    border: 1px #d7d7d7 solid;
    border-radius: 6px;
    background: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
  }

  &__post-snippet {
    margin-bottom: 19px;
  }

  &__post-snippet-textarea {
    scroll-behavior: smooth;
  }
}

@mixin skeletonElement {
  border-radius: 3px;
  background: #e8e8e8;
  color: transparent;
}

.post-preview-section-skeleton {
  display: flex;
  align-items: stretch;

  .photos-section {
    margin: 15px -9px 0;
    gap: 4px;
    display: flex;
    flex-wrap: wrap;

    &__photo {
      aspect-ratio: 1/1;
      @include skeletonElement;
      @include skeletonLoading;

      &--big {
        width: calc(50% - 4px / 2);
      }

      &--small {
        width: calc(33.3% - 4px * 2 / 3);
      }
    }
  }

  .buttons-panel {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    &__button {
      height: 33px;
      @include skeletonElement;
      @include skeletonLoading;

      &--big {
        width: 170px;
      }

      &--small {
        width: 50px;
      }
    }
  }

  .post-preview-section {
    position: relative;
    z-index: 0;

    &__post-snippet-wrap {
      position: relative;
      z-index: -1;
    }

    &__slot-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      inset: 0 auto auto 0;
      z-index: 2;
    }

    &__snippet {
      padding: 0 10px;
      position: relative;
      overflow: hidden;
    }

    &__snippet-text {
      @include skeletonElement;
      @include skeletonLoading;
      box-decoration-break: clone;
      -webkit-box-decoration-break: clone;
      color: transparent;
      user-select: none;
    }
  }
}
</style>
